export default __webpack_public_path__ + "static/media/man-right-2.a0eb3fe9.png";